import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { IncidentsGuard } from '@tokeet-frontend/incident'
import { TaskResponse } from '@tokeet-frontend/tasks'
import { DataCheckerService, Destroyable } from '@tokeet-frontend/tv3-platform'

export enum ApproveDraftTasksDialogTabs {
  Message,
  Review,
  Automation,
}

export interface ApproveDraftTasksDialogParams {
  inquiryId?: string
  tab?: ApproveDraftTasksDialogTabs
}

@Component({
  selector: 'app-approve-draft-tasks-dialog',
  templateUrl: './approve-draft-tasks-dialog.component.html',
  styleUrls: ['./approve-draft-tasks-dialog.component.scss'],
})
export class ApproveDraftTasksDialogComponent extends Destroyable implements OnInit {
  tabs = ApproveDraftTasksDialogTabs
  tab = ApproveDraftTasksDialogTabs.Message
  drafts: TaskResponse[] = []
  showTabs = true

  constructor(
    private dialogRef: MatDialogRef<ApproveDraftTasksDialogComponent>,
    private dataChecker: DataCheckerService,
    @Inject(MAT_DIALOG_DATA) public data: ApproveDraftTasksDialogParams
  ) {
    super()
    this.showTabs = !this.data.inquiryId
    this.dataChecker.check([IncidentsGuard])
  }

  ngOnInit(): void {
    this.tab = this.data.tab ?? ApproveDraftTasksDialogTabs.Message
  }

  close() {
    this.dialogRef.close()
  }
}
